import { useState } from 'react'
import classNames from 'classnames'

import { RatingItem } from '../RatingItem'

import { RATING_ITEM_SIZE, RATING_LINE_LENGTH } from './Rating.constants'
import { getIsRatingItemFilled } from './Rating.utils'

import * as styles from './Rating.module.css'

function Rating({
  disabled,
  interactable,
  itemSize = RATING_ITEM_SIZE.size16,
  length = RATING_LINE_LENGTH,
  rating,
  onClickItem,
  onClickRow,
  onMouseDownRow,
  ...restProps
}) {
  const [hoverValue, setHoverValue] = useState(0)

  const isPicker = Boolean(onClickItem) && !disabled

  const ratingClassName = classNames(styles.rating, {
    [styles.hoverRow]: !!onClickRow,
    [styles.noInteractable]: !interactable,
  })

  function handleResetHover() {
    setHoverValue(0)
  }

  return (
    <div
      className={ratingClassName}
      onClick={onClickRow}
      onMouseDown={onMouseDownRow}
      onMouseLeave={isPicker ? handleResetHover : undefined}
    >
      {Array.from({ length }).map((_, index) => {
        const value = index + 1

        return (
          <RatingItem
            {...restProps}
            disabled={disabled || !interactable}
            filled={getIsRatingItemFilled({ hoverValue, rating, value })}
            itemSize={itemSize}
            key={index}
            themed={value <= hoverValue}
            value={value}
            onClickItem={onClickItem}
            onHover={isPicker ? setHoverValue : undefined}
          />
        )
      })}
    </div>
  )
}

export default Rating
